import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _BulkPayoutsIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3C7.03228 3 3 7.03228 3 12C3 16.9677 7.03228 21 12 21C16.9677 21 21 16.9677 21 12C21 11.4477 21.4477 11 22 11C22.5523 11 23 11.4477 23 12C23 18.0723 18.0723 23 12 23C5.92772 23 1 18.0723 1 12C1 5.92772 5.92772 1 12 1C12.5523 1 13 1.44772 13 2C13 2.55228 12.5523 3 12 3ZM18 3C17.4477 3 17 2.55228 17 2C17 1.44772 17.4477 1 18 1H22C22.5523 1 23 1.44772 23 2V6C23 6.55228 22.5523 7 22 7C21.4477 7 21 6.55228 21 6V4.41421L18.0196 7.39461C17.6291 7.78513 16.9959 7.78513 16.6054 7.39461C16.2149 7.00408 16.2149 6.37092 16.6054 5.98039L19.5858 3H18ZM7 10.5313C7 8.521 8.39342 6.9243 10.2372 6.29283C10.7876 6.10255 11.3819 6 12 6C13.345 6 14.5778 6.47848 15.4905 7.27976L15.4973 7.28574C16.4006 8.09336 17 9.23503 17 10.5313V13.6563C17 16.3369 14.5644 18 12 18C9.43555 18 7 16.3369 7 13.6563V10.5313ZM14.9221 14.2022C14.6352 15.1915 13.5721 16 12 16C10.4279 16 9.36482 15.1915 9.07793 14.2022C9.918 14.7207 10.9374 15 12 15C13.0626 15 14.082 14.7207 14.9221 14.2022ZM12 8C12.8635 8 13.6209 8.3113 14.161 8.79257C14.6965 9.28158 15 9.91873 15 10.5955C15 10.994 14.895 11.353 14.7145 11.6585L14.7133 11.6605C14.2667 12.4201 13.2771 13 12 13C10.7229 13 9.7333 12.4201 9.28667 11.6605L9.28552 11.6585C9.10501 11.353 9 10.994 9 10.5955C9 9.91666 9.30519 9.28017 9.83881 8.7991C10.3777 8.31271 11.135 8 12 8Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const BulkPayoutsIcon = assignWithoutSideEffects(_BulkPayoutsIcon, {
  componentId: 'BulkPayoutsIcon',
});

export default BulkPayoutsIcon;
